import { useState, useEffect } from "react";
import UserNavbar from "./UserNavbar";
import UserSidebar from "./UserSidebar";

export default function UserLayout({ children }) {

  const [open, setOpen] = useState(false);

  // auto open desktop, close mobile
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 992) {
        setOpen(true);
      } else {
        setOpen(false);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <UserNavbar toggleSidebar={() => setOpen(!open)} />

      <div className="d-flex">

        <UserSidebar open={open} close={() => setOpen(false)} />

        <div className="flex-grow-1">
          {children}
        </div>

      </div>
    </>
  );
}